import * as React from "react";
function SvgMenu(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "none",
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M3 6H21" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /><path d="M3 12H21" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /><path d="M3 18H21" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "src/assets/icons/menu.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/menu_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/menu_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/menu_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/menu_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/menu_4x.svg"
};
export { ForwardRef as ReactComponent };